import { arrayUniquePush } from '@/app/utils/nativeArray';
import type { State } from './state';

const mutations = {
  ADD_OPTIONS_FONTS(state: State, font: any) {
    if (['', 'inherit', 'Inherit'].includes(font.styleName)) return;
    font.styleName = font.styleName.replace('+', ' ');
    font.googleName = font.googleName.replace('+', ' ');
    arrayUniquePush(state.optionFonts, font, (item) => {
      return item.styleName === font.styleName && item.custom === font.custom;
    });
  },
  ADD_ACTIVE_FONTS(state: State, font: any) {
    font.isActive = true;
    state.activeFonts.push(font);
  },
  REMOVE_ACTIVE_FONTS(state: State, font: any) {
    font.isActive = false;
    const removedIndex = state.activeFonts.findIndex(
      (item) => item.styleName == font.styleName && item.custom == font.custom,
    );
    if (removedIndex > -1) {
      state.activeFonts.splice(removedIndex, 1);
    }
  },
  ADD_EDITING_FONT(state: State, font: any) {
    arrayUniquePush(state.editingFonts, font, (item) => item.styleName === font.styleName);
  },
  REMOVE_EDITING_FONT(state: State, font: any) {
    const removedIndex = state.editingFonts.findIndex((item) => item.styleName == font.styleName);
    if (removedIndex > -1) {
      state.editingFonts.splice(removedIndex, 1);
    }
  },
  APPLY_SETUP_FONT_SELETOR(state: State, payload: { id: string; data: any }) {
    const { id, data } = payload;
    state.setupFontSelector.set(id, data);
  },
  SET_CONTAINER_RIGHT(state: State, right: number) {
    state.containerRight = right;
  },
  SET_UPLOAD_STATUS(state: State, status: string) {
    state.uploadStatus = status;
  },
  SET_UPLOAD_NUMBER(state: State, number: number) {
    state.uploadNumber = number;
  },
};

export default mutations;
